<template>
  <div class="footer-wrapper" :class="{ 'isDsiabledToSend': !isAbleSend, 'isMobile': isMobile }">
    <!-- 全屏拖拽覆盖层 -->
    <div v-if="isGlobalDragOver" class="global-drop-overlay" @click="closeDropOverlay">
      <div class="drop-hint">📸 在此处拖放图片</div>
    </div>
    <div id="footer">
      <div class="footer-input" :class="isActive ? 'active' : ''" ref="footerMiddle">
        <div class="footer-top" v-if="fileList && fileList.length > 0">
          <file-display :fileList="fileList" :isMain="false" @delFile="handleDelFile" @uploadFile="handleFileUpload" @viewVirtual="handleViewVirtualFile">
          </file-display>
        </div>
        <div class="footer-bottom">
          <el-tooltip placement="top" content="新建对话">
            <svg class=" icon icon-new" @click="newSessionClick(true)" t="1743582654352" viewBox="0 0 1024 1024"
              version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="19471">
              <path
                d="M825.6 21.44c23.488 0 42.56 19.072 42.56 42.56v91.84H960a42.56 42.56 0 1 1 0 85.12h-91.84V332.8a42.56 42.56 0 1 1-85.12 0V240.96H691.2a42.56 42.56 0 0 1 0-85.12h91.84V64c0-23.488 19.072-42.56 42.56-42.56z"
                p-id="19472"></path>
              <path
                d="M106.56 332.8A181.44 181.44 0 0 1 288 151.36h290.24a42.56 42.56 0 0 0 0-85.12H288A266.56 266.56 0 0 0 21.44 332.8v247.36a266.624 266.624 0 0 0 231.872 264.32l27.2 124.608a42.56 42.56 0 0 0 68.608 23.808l165.12-135.488a47.04 47.04 0 0 1 29.824-10.688h192c147.2 0 266.496-119.296 266.496-266.56v-134.4a42.56 42.56 0 1 0-85.12 0v134.4A181.44 181.44 0 0 1 736 761.6H544.064c-30.528 0-60.16 10.624-83.84 30.016l-111.36 91.392-19.2-87.936a42.56 42.56 0 0 0-41.6-33.472 181.44 181.44 0 0 1-181.504-181.44V332.8z"
                p-id="19473"></path>
            </svg>
          </el-tooltip>
          <el-tooltip placement="top" content="一键折叠">
            <svg t="1752735199056" class="icon icon-fold" @click="foldContent" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="10521" width="28" height="28">
              <path
                d="M0 512a512 512 0 1 0 1024 0A512 512 0 0 0 0 512z m534.08-243.072a20.032 20.032 0 0 1 3.712 2.24l1.408 0.704c2.752 1.472 6.336 3.328 9.792 6.656l0.192 0.256c0.256 0.128 0.448 0.384 0.64 0.576 0.896 0.64 1.728 1.344 2.56 2.176l288.64 299.392a56.96 56.96 0 1 1-82.176 79.232L510.336 402.368 265.6 661.12a57.216 57.216 0 0 1-98.56-39.232c0-14.72 5.568-28.608 15.616-39.232l285.696-301.952a56.576 56.576 0 0 1 65.792-11.776z"
                p-id="10522"></path>
            </svg>
          </el-tooltip>
          <div class="upload-wrapper">
            <el-tooltip placement="top" content="传图答疑" :disabled="isMobile || !isAbleSend">
              <el-upload
                ref="upload"
                class="upload-demo"
                multiple
                action=""
                :on-remove="handleRemove"
                :before-upload="handleBeforeUpload"
                :http-request="handleFileUpload"
                :limit="10"
                :on-exceed="handleExceed"
                :show-file-list="false"
                :file-list="fileList"
                :disabled="!isAbleSend"
                accept=".jpg,.jpeg,.png,.md"
              >
                <div slot="trigger">
                  <svg @click="handleUploadClick($event)" t="1742453244781" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="7461" width="28"
                    height="28">
                    <path class="fill-first"
                      d="M184.32 143.36h655.36a122.88 122.88 0 0 1 122.88 122.88v491.52a122.88 122.88 0 0 1-122.88 122.88H184.32a122.88 122.88 0 0 1-122.88-122.88V266.24a122.88 122.88 0 0 1 122.88-122.88z"
                      p-id="7462"></path>
                    <path d="M225.28 307.2m-61.44 0a61.44 61.44 0 1 0 122.88 0 61.44 61.44 0 1 0-122.88 0Z" fill="#FFFFFF"
                      p-id="7463"></path>
                    <path
                      d="M194.88768 780.288a41.24672 41.24672 0 0 1-35.84-61.68576l93.98272-164.2496a41.30816 41.30816 0 0 1 71.68 0l101.31456 177.07008 190.11584-273.408a41.30816 41.30816 0 0 1 67.80928 0L863.0272 715.5712a41.18528 41.18528 0 0 1-33.91488 64.73728H194.88768z"
                      fill="#FFFFFF" p-id="7464"></path>
                  </svg>
                </div>
              </el-upload>
            </el-tooltip>
          </div>
          <div class="editor" placeholder="有什么想问的，尽管告诉我～" ref="inputRef" id="testMultiple" contenteditable="true"
            @focus="handleFocus" @blur="handleBlur" @keydown="textareaKeydown($event)" @input="handleInput($event)">
          </div>

          <!-- 发送/停止按钮区域 - 改动 -->
          <div class="send-btn" @click="send" v-if="!isGenerating">
            <i class="el-icon-s-promotion" :class="getInputClass"></i>
          </div>
          <div class="stop-btn" @click="stopGeneration" v-else>
            <i class="el-icon-close" style="font-size:28px; color:#ff4d4f;"></i>
          </div>
          <!-- 原有loading-btn已移除，停止按钮替代 -->
        </div>
      </div>
      <el-dialog :visible.sync="voiceDialogVisible">
        <div class="mainBox">
          <div style="
            height: 100px;
            width: 90%;
            border: 1px solid #ccc;
            box-sizing: border-box;
            display: inline-block;
            vertical-align: bottom;
          " class="ctrlProcessWave"></div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleVoiceCancel">取 消</el-button>
          <el-button type="primary" @click="recStop">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog 
        title="文件内容" 
        :visible.sync="virtualFileDialogVisible" 
        width="70%"
        :close-on-click-modal="true"
        append-to-body
      >
        <div style="max-height: 400px; overflow-y: auto; white-space: pre-wrap; word-break: break-all; font-family: monospace;">
          {{ virtualFileContent }}
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="virtualFileDialogVisible = false">关闭</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 移动端选择拍照/相册的动作面板 -->
    <div v-if="showActionSheet" class="action-sheet-mask" @click.self="showActionSheet = false">
      <div class="action-sheet">
        <div class="action-sheet-item" @click="chooseCamera">📸 拍题答疑</div>
        <div class="action-sheet-item" @click="chooseAlbum">🖼️ 从相册选择</div>
        <div class="action-sheet-item cancel" @click="showActionSheet = false">❌ 取消</div>
      </div>
    </div>

    <!-- 自定义相机遮罩层（取景框） -->
    <div v-if="showCamera" class="camera-overlay" @click.self="closeCamera">
      <div class="camera-container" ref="cameraContainer">
        <video ref="cameraVideo" class="camera-video" autoplay playsinline></video>

        <!-- 预览层：拍摄后显示静态图片，等待确认 -->
        <div v-if="isPreviewing" class="camera-preview">
          <img :src="capturedImageUrl" alt="拍摄预览" />
          <div class="preview-actions">
            <button class="btn-retake" @click="retakePhoto">⟲ 重拍</button>
            <button class="btn-confirm" @click="confirmPhoto">✓</button>
          </div>
        </div>

        <!-- 取景框（仅在非预览时显示） -->
        <div v-if="!isPreviewing" class="crop-box" :style="cropBoxStyle" @touchstart="startDrag" @touchmove.prevent="onTouchMove" @touchend="onTouchEnd">
          <div class="crop-area">
            <div class="crop-hint">
              可拖拉取景框<br/>
              平行纸面拍照<br/>
              题目放入框内
            </div>
          </div>
          <div class="resize-handle" @touchstart="startResize($event)" @touchmove.prevent="onTouchMove" @touchend="onTouchEnd"></div>
        </div>

        <!-- 底部按钮：预览时只显示取消，非预览显示原有按钮 -->
        <div class="camera-footer" v-if="!isPreviewing">
          <button class="btn-cancel" @click="closeCamera">取消</button>
          <button class="btn-album" @click="chooseAlbumFromCamera">相册</button>
          <button class="btn-capture" @click="takePhoto">拍照</button>
        </div>
        <div class="camera-footer" v-if="isPreviewing">
          <button class="btn-cancel" @click="closeCamera">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store/index";
import pubsub from "pubsub-js";

import chatMixin from "@/mixin/chat.js";
import { mapState } from "vuex";
import * as request from "@/utils/request";
// 录音相关
import Recorder from "recorder-core"; 
import "recorder-core/src/engine/mp3";
import "recorder-core/src/engine/mp3-engine";
import "recorder-core/src/extensions/waveview";

import humenAvatar from "@/assets/image/chat/humen.svg";
import electricaiAvatar from "@/assets/image/chat/logo.svg";
import otherFileIcon from "@/assets/image/chat/other_file.png";
import txtFileIcon from "@/assets/image/chat/txt_file.png";
import xlsxFileIcon from "@/assets/image/chat/xlsx_file.png";
import fileDisplay from "./fileDisplay.vue";
import { createAutoMsg } from '@/utils/chat/autoMsg'
import { nanoid } from 'nanoid';
import _ from "lodash";
import robot from "../../mixin/robot";
const UPDATE_MESSAGE = "UPDATE_MESSAGE";
const ELECTRIC_AI = "ChatGrid";
import { parseUserMessage } from '@/utils/chat/messageParser';

export default {
  data() {
    return {
      // [优化] 新增虚拟文件查看弹窗控制
      virtualFileDialogVisible: false,
      virtualFileContent: '',

      pasteHandler: null,

      isGlobalDragOver: false,   // 控制覆盖层显示
      dragCounter: 0,            // 防闪烁计数器
      // 全局事件处理器（用于移除）
      globalDragEnterHandler: null,
      globalDragOverHandler: null,
      globalDragLeaveHandler: null,
      globalDropHandler: null,


      api: "",
      header: {},
      content: "",
      caseText: "",
      answerOptions: [],
      checkedTypes: [],
      avatarCheckedTypes: [],
      fileList: [],
      type: "qa",
      node: "", // 获取到节点
      user: "", // 选中项的内容
      endIndex: "", // 光标最后停留位置
      queryString: "", // 搜索值
      showDialog: false, // 是否显示弹窗
      timer: null,
      isActive: false,
      globalLoading: false,
      imgBtnSrc: electricaiAvatar,
      voiceDialogVisible: false,
      duration: 0,
      durationTxt: "0",
      powerLevel: 0,
      logs: [],
      isBuiltLib: false,
      sessionPromise: null,
      // 记住最近一轮的回答
      lastAnswerContent: {
        text: "",
      },
      position: {
        x: 0,
        y: 0,
      }, // 弹窗显示位置
      chatAvatar: {
        [ELECTRIC_AI]: electricaiAvatar,
        my: humenAvatar,
      },
      // 移动端拍照取景框相关
      showActionSheet: false,
      showCamera: false,
      cameraStream: null,
      videoWidth: 0,
      videoHeight: 0,
      // 取景框位置和大小（相对于父容器的百分比）
      cropBox: {
        left: 0.01,
        top: 0.25,
        width: 0.98,
        height: 0.3,
      },
      // 拖动调整相关
      isDragging: false,
      isResizing: false,
      dragStartData: {
        startX: 0,
        startY: 0,
        startLeft: 0,
        startTop: 0,
        startWidth: 0,
        startHeight: 0,
        containerWidth: 0,
        containerHeight: 0,
      },
      // ---- 新增：拍照预览状态 ----
      isPreviewing: false,
      capturedImageUrl: null,
      capturedFile: null,
      confirming: false,
    };
  },
  mixins: [chatMixin],
  components: {
    fileDisplay,
  },
  created() {
    this.Rec = Recorder;
  },
  mounted() {
    //创建一个对话（数组）
    // this.newSession();
    this.pasteText();
    this.setupGlobalDragDrop();  // 新增
    this.subscribeInput();
    this.subscribeQuestion();
    // 每日一问，创建新对话时自动获取问题
    this.subscribeEverydayQuestion();
    this.subscribeLibAlreadyBuild();
  },
  beforeDestroy() {
    this.removeTouchListeners();
    const editor = this.$refs.inputRef;
    if (editor && this.pasteHandler) {
      editor.removeEventListener('paste', this.pasteHandler);
    }

    // 移除全局监听
    if (this.globalDragEnterHandler) {
      document.removeEventListener('dragenter', this.globalDragEnterHandler);
    }
    if (this.globalDragOverHandler) {
      document.removeEventListener('dragover', this.globalDragOverHandler);
    }
    if (this.globalDragLeaveHandler) {
      document.removeEventListener('dragleave', this.globalDragLeaveHandler);
    }
    if (this.globalDropHandler) {
      document.removeEventListener('drop', this.globalDropHandler);
    }

    // 释放预览资源
    if (this.capturedImageUrl) {
      URL.revokeObjectURL(this.capturedImageUrl);
    }
  },
  methods: {
    // [优化] 查看虚拟文件内容
    handleViewVirtualFile(file) {
      if (file.isVirtual && file.content) {
        this.virtualFileContent = file.content;
        this.virtualFileDialogVisible = true;
      } else {
        this.$message.warning('该文件无法预览');
      }
    },
      // 关闭拖拽覆盖层（用户点击时调用）
    closeDropOverlay() {
      this.isGlobalDragOver = false;
      this.dragCounter = 0; // 防止计数器残留影响后续拖放
    },
    
    async fetchImageAsFile(url) {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        if (blob.type.startsWith('image/')) {
          const fileName = url.split('/').pop() || 'image.jpg';
          const file = new File([blob], fileName, { type: blob.type });
          file.uid = Date.now() + Math.random().toString(36).substr(2);
          this.processFile(file);
        }
      } catch (err) {
        console.error('获取拖拽图片失败', err);
        this.$message.warning('无法获取该图片，请尝试保存到本地后上传');
      }
    },
      
    async processFile(file) {
      if (!file.uid) {
        file.uid = Date.now() + Math.random().toString(36).substr(2);
      }
      const result = await this.handleBeforeUpload(file, this.fileList);
      if (result !== false) {
        await this.handleFileUpload({ file });
      }
    },

    recOpen() {
      if (!this.isAbleSend) {
        return;
      }
      var This = this;
      var rec = (this.rec = Recorder({
        type: "mp3",
        bitRate: 16,
        sampleRate: 16000,
        onProcess: function (buffers, powerLevel, duration, sampleRate) {
          This.duration = duration;
          This.durationTxt = This.formatMs(duration, 1);
          This.powerLevel = powerLevel;
          This.wave.input(buffers[buffers.length - 1], powerLevel, sampleRate);
        },
      }));

      rec.open(
        function () {
          This.voiceDialogVisible = true;
          This.$nextTick(() => {
            This.wave = Recorder.WaveView({ elem: ".ctrlProcessWave" });
            This.recStart();
          });
        },
        function (msg, isUserNotAllow) {
          this.$message.warning("用户不允许访问麦克风");
          this.voiceDialogVisible = false;
          return;
        }
      );
    },
    recStart: function () {
      if (!this.rec || !Recorder.IsOpen()) {
        return;
      }
      this.rec.start();

      var set = this.rec.set;
    },
    recStop() {
      if (!this.rec) {
        console.error("未打开录音");
        return;
      }
      this.rec.stop(
        (blob, duration) => {
          //blob就是我们要的录音文件对象，可以上传，或者本地播放
          this.recBlob = blob;
          //简单利用URL生成本地文件地址，此地址只能本地使用，比如赋值给audio.src进行播放，赋值给a.href然后a.click()进行下载（a需提供download="xxx.mp3"属性）
          var localUrl = (window.URL || webkitURL).createObjectURL(blob);
          console.log("录音成功", blob, localUrl, "时长:" + duration + "ms");

          this.uploadVoice(blob); //把blob文件上传到服务器

          this.rec.close(); //关闭录音，释放录音资源，当然可以不释放，后面可以连续调用start
          this.rec = null;
        },
        (err) => {
          console.error("结束录音出错：" + err);
          this.rec.close(); //关闭录音，释放录音资源，当然可以不释放，后面可以连续调用start
          this.rec = null;
        }
      );
    },
    async uploadVoice(blob) {
      if (!blob) {
        return;
      }
      let { robotId, sessionId } = this;
      var form = new FormData();
      form.append("file", blob, "recorder.mp3"); //和普通form表单并无二致，后端接收到upfile参数的文件，文件名为recorder.mp3
      //...其他表单参数
      form.append("sessionId", "124567890");
      // console.log(this.sessionId);
      const res = await request.post("/uploadChat", form);
      this.voiceDialogVisible = false;
      if (res.data && res.data.message === 1) {
        this.$message.success("上传成功");
        let myMsg = {
          type: "my",
          msg: this.content && this.content.trim(),
          voiceUrl: URL.createObjectURL(blob),
          fileType: "voice",
          avatar: humenAvatar,
          robotId,
          sessionId,
          isCollapse: false,   // 添加默认展开
        };
        // store.commit(UPDATE_MESSAGE, { key: this.sessionId, msg: myMsg });
        await this.$store.dispatch('addMessageToConversation', {
          message: myMsg
        });

      } else {
        this.$message.warning("上传失败");
      }
    },
    recPlay() {
      //本地播放录音试听，可以直接用URL把blob转换成本地播放地址，用audio进行播放
      var localUrl = URL.createObjectURL(this.recBlob);
      var audio = document.createElement("audio");
      audio.controls = true;
      document.body.appendChild(audio);
      audio.src = localUrl;
      audio.play(); //这样就能播放了

      //注意不用了时需要revokeObjectURL，否则霸占内存
      setTimeout(function () {
        URL.revokeObjectURL(audio.src);
      }, 5000);
    },

    formatMs(ms, all) {
      var ss = ms % 1000;
      ms = (ms - ss) / 1000;
      var s = ms % 60;
      ms = (ms - s) / 60;
      var m = ms % 60;
      ms = (ms - m) / 60;
      var h = ms;
      var t =
        (h ? h + ":" : "") +
        (all || h + m ? ("0" + m).substr(-2) + ":" : "") +
        (all || h + m + s ? ("0" + s).substr(-2) + "″" : "") +
        ("00" + ss).substr(-3);
      return t;
    },
    reclog(msg, color, res) {
      var obj = {
        idx: this.logs.length,
        msg: msg,
        color: color,
        res: res,

        playMsg: "",
        down: 0,
        down64Val: "",
      };
      if (res && res.blob) {
        this.recLogLast = obj;
      }
      this.logs.splice(0, 0, obj);
    },
    handleVoiceCancel() {
      this.voiceDialogVisible = false;
      this.rec.close();
    },
    subscribeInput() {
      pubsub.subscribe("copyText", (msgName, msg) => {
        this.$refs.inputRef.innerText = msg;
        this.content = msg;
      });
    },
    subscribeQuestion() {
      pubsub.subscribe("sendRequest", async (msgName, msg) => {
        this.content = msg;
        await this.send();
        // this.$router.push(`/chatSearch/${this.robotId}`);
      });
    },
    subscribeEverydayQuestion() {
      pubsub.subscribe("getEveryDayQuestion", async (msgName, params) => {
        await this.getElectricAiAnswer(params);
      });
    },

    // 建立知识库？
    subscribeLibAlreadyBuild() {
      pubsub.subscribe("ableToSend", (msgName, msg) => {
        this.isBuiltLib = true;
      });
    },
    // 获取文件类型
    getFileType(file) {
      let fileType = file.name.split(".").pop();
      if (fileType === "xlsx") {
        return xlsxFileIcon;
      } else if (fileType === "txt") {
        return txtFileIcon;
      } else {
        return otherFileIcon;
      }
    },

    pasteText() {
      const editor = this.$refs.inputRef;
      if (!editor) return;

      this.pasteHandler = async (e) => {
        e.preventDefault();
        const clipboardData = e.clipboardData || window.clipboardData;
        if (!clipboardData) return;

        const items = clipboardData.items;
        let plainText = '';

        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (item.type && item.type.indexOf('image') !== -1) {
            const file = item.getAsFile();
            if (file) {
              await this.processFile(file);
            }
          } else if (item.type === 'text/plain') {
            plainText = await new Promise(resolve => item.getAsString(resolve));
          }
        }

        if (plainText) {
          const THRESHOLD = 200;
          if (plainText.length > THRESHOLD) {
            const virtualFile = {
              uid: Date.now() + '_virtual_' + Math.random().toString(36).substr(2),
              name: `长文本_${Date.now()}.txt`,
              size: plainText.length,
              type: 'txt',
              isVirtual: true,
              content: plainText,
              iconUrl: txtFileIcon,
              percentage: 100,
              isImg: false,
            };
            this.fileList.push(virtualFile);
            this.$message.success('长文本已收纳为文件，可继续输入');
          } else {
            const sel = window.getSelection();
            if (sel && sel.rangeCount) {
              const range = sel.getRangeAt(0);
              range.deleteContents();
              const textNode = document.createTextNode(plainText);
              range.insertNode(textNode);
              range.setStartAfter(textNode);
              range.collapse(true);
              sel.removeAllRanges();
              sel.addRange(range);
            } else {
              document.execCommand('insertText', false, plainText);
            }
            this.content = editor.innerText;
          }
        }
      };

      editor.addEventListener('paste', this.pasteHandler);
    },

    setupGlobalDragDrop() {
      this.globalDragEnterHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter++;
        if (this.dragCounter === 1) {
          this.isGlobalDragOver = true;
        }
      };

      this.globalDragOverHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.dataTransfer.dropEffect = 'copy';
        if (this.dragCounter === 0) {
          this.dragCounter = 1;
          this.isGlobalDragOver = true;
        }
      };

      this.globalDragLeaveHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter--;
        if (this.dragCounter <= 0) {
          this.dragCounter = 0;
          this.isGlobalDragOver = false;
        }
      };

      this.globalDropHandler = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter = 0;
        this.isGlobalDragOver = false;

        const files = e.dataTransfer.files;
        if (files.length > 0) {
          for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (file.type && file.type.startsWith('image/')) {
              await this.processFile(file);
            }
          }
        } else {
          const url = e.dataTransfer.getData('text/uri-list') ||
                      e.dataTransfer.getData('text/plain');
          if (url && url.match(/\.(jpg|jpeg|png|gif|webp|bmp)/i)) {
            await this.fetchImageAsFile(url);
          }
        }
      };

      document.addEventListener('dragenter', this.globalDragEnterHandler);
      document.addEventListener('dragover', this.globalDragOverHandler);
      document.addEventListener('dragleave', this.globalDragLeaveHandler);
      document.addEventListener('drop', this.globalDropHandler);
    },

    async handleFileUpload(fileObj) {
      const { file } = fileObj;

      // 1. 根据 uid 查找对应的文件项（使用 find 更简洁）
      let selected = this.fileList.find(item => item.uid === file.uid);

      // 2. 如果未找到，主动构造一个项（避免后续报错），并提示用户
      if (!selected) {
        console.warn('未找到匹配的文件项，uid:', file.uid, '当前fileList:', this.fileList);
        // 可尝试重新调用 handleBeforeUpload 加入，但会重复，所以直接报错并返回
        this.$message.error('文件状态异常，请重新上传');
        return;
      }

      // 3. 开始上传，设置进度为0
      this.$set(selected, 'percentage', 0);

      // 4. 确保有 sessionId（复用原有逻辑）
      if (!this.sessionId) {
        if (!this.sessionPromise) {
          this.sessionPromise = this.newSession(file.name);
        }
        await this.sessionPromise;
        this.sessionPromise = null;
      }

      if (!this.sessionId) {
        this.$set(selected, 'percentage', -100);
        this.$message.error('上传失败：无法创建会话');
        return;
      }

      this.$set(selected, 'sessionId', this.sessionId);

      try {
        const formData = new FormData();
        formData.append('file', file);
        const res = await request.post('/uploadChat', formData);
        const message = res.data?.message;

        // 5. 使用宽松比较（==）兼容字符串和数字
        if (message == 1) {
          this.$set(selected, 'percentage', 100);
          this.$set(selected, 'sessionId', this.sessionId);
          this.$message.success('上传成功');
        } else {
          this.$set(selected, 'percentage', -100);
          this.$message.error('上传失败：' + (res.data?.msg || '未知错误'));
        }
      } catch (error) {
        console.error('上传请求异常:', error);
        this.$set(selected, 'percentage', -100);
        this.$message.error('上传请求异常，请重试');
      }
    },
    handleDelFile(item) {
      this.fileList.forEach((file, index) => {
        if (file.uid === item.uid) {
          this.fileList.splice(index, 1);
          this.$message.info("删除成功");
        }
      });
    },
    async handleBeforeUpload(file, fileList) {
      // 防止重复添加（用于兜底）
      if (this.fileList.some(item => item.uid === file.uid)) {
        return false;
      }
      if ((file.size / (1024 * 1024)).toFixed(2) > 20) {
        this.$message.error("上传的文件不能大于20M");
        return false;
      }
      if (file.name) {
        let names = file.name.split(".");
        if (!["jpg", "jpeg", "png", "md"].includes(names[names.length - 1].toLowerCase())) {
          this.$message.error("仅支持文件扩展名为jpg、jpeg、png的图片，请您重新上传")
          return false
        }
      }

      let item = {
        uid: file.uid,
        name: file.name,
        size: file.size,
        percentage: 0,
        file,
        sessionId: this.sessionId,
      };
      let index = file.name.lastIndexOf(".");
      let type = file.name.slice(index).toLowerCase();
      item.type = type.replace(".", "");
      if ([".xlsx", ".xls"].includes(type)) {
        item.iconUrl = xlsxFileIcon;
      } else if ([".txt", ".doc", ".docx", ".dotx", ".md"].includes(type)) {
        item.iconUrl = txtFileIcon;
      } else if (
        [
          ".png",
          ".svg",
          ".jpg",
          ".jpeg",
          ".bmp",
          ".tiff",
          ".raw",
          ".gif",
          ".webp",
        ].includes(type)
      ) {
        item.iconUrl = URL.createObjectURL(file);
        item.isImg = true;
      } else {
        item.iconUrl = otherFileIcon;
      }

      this.fileList.push(item);




    },
    handleSuccess(response, file, fileList) {
      // console.log(file);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    handleFocus() {
      this.isActive = true;
      store.commit("SET_isKeyboardOpen", true);
    },
    handleBlur() {
      this.isActive = false;
      store.commit("SET_isKeyboardOpen", false);
    },
    handleInput(e) {
      this.content = e.target.innerText
    },

    valueChange(e) { },
    changeMsg(selectInfo) {
      const arr = selectInfo.split("-");
      this.type = arr[0];
      this.caseText = arr[1];
    },
    handleEditorBlur() {
      // setTimeout(() => {
      //   this.showDialog = false;
      // });
    },
    formatDate(date) {
      let year = date.getFullYear();
      let month = ("0" + (date.getMonth() + 1)).slice(-2);
      let day = ("0" + date.getDate()).slice(-2);
      let hour = ("0" + date.getHours()).slice(-2);
      let minute = ("0" + date.getMinutes()).slice(-2);
      let second = ("0" + date.getSeconds()).slice(-2);
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second
      );
    },
    //获取模拟回答
    async getBeLikeAnswer(params) {
      //电力回复的消息
      let electricaiMsg = {
        type: ELECTRIC_AI,
        paintType: "",
        msg: "loading",
        distributeInfo: {},
        freqInfo: {},
        title: "",
        table: [],
        base64: [],
        filename: [],
        createTime: this.formatDate(new Date()),
        avatar: electricaiAvatar,
      };
      store.commit(UPDATE_MESSAGE, {
        robotId: this.robotId,
        key: this.sessionId,
        msg: electricaiMsg,
      });
      // this.lastAnswerContent.id = this.$route.query.id;
      //請求回答
      request
        .get("http://localhost:8080/data/chat.json")
        .then((res) => {
          try {
            if (res.status === 200) {
              let { data } = res;
              // 判断是否为空数据
              electricaiMsg.msg = null;
              // if (data.data) {
              //   // this.paintFreqTable(data.data, electricaiMsg);
              //   this.paintTable(data.data, electricaiMsg);
              // }
              // if()
              electricaiMsg.table = data.table;
              electricaiMsg.title = data.title;
              // electricaiMsg.msg = data.content;
              electricaiMsg.msg = data.content;
              electricaiMsg.filename = data.filename;
              electricaiMsg.base64 =
                data.base64 &&
                data.base64.map((base64Str, index) => ({
                  url: "data:image/png;base64," + base64Str,
                  enlarged: false,
                }));
            } else {
              //测试用
              electricaiMsg.msg = "暂无数据";
            }
          } catch (error) {
            console.log(error);
            electricaiMsg.msg = "暂无数据";
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 获取习题答案回复
    async getExercisesAnswer(robotId, sessionId, params) {
      let electricaiMsg = createAutoMsg(
        this.robots[robotId].avatar,
        this.$delete
      );
      electricaiMsg.params = params;
      electricaiMsg.robotId = robotId;
      electricaiMsg.sessionId = sessionId;
      // store.commit(UPDATE_MESSAGE, {
      //   robotId: this.robotId,
      //   key: this.sessionId,
      //   msg: electricaiMsg,
      // });
      await this.$store.dispatch('addMessageToConversation', {
        message: electricaiMsg
      });

      //請求回答
      let paramsObj = {
        ...params,
        answerUrl: this.robots[robotId].answerUrl,
        aiContent: electricaiMsg,
      };
      let copyParams = _.clone(paramsObj);

      this.robots[robotId].getStreamAnswer(copyParams);
    },
    paintTable(tableList, electricaiMsg) {
      tableList.forEach((item, index) => { });
    },

    async send() {
        let { robotId, sessionId } = this;

        let inputText = this.content && this.content.trim() || '';
        let virtualFiles = this.fileList.filter(f => f.isVirtual);
        let realFiles = this.fileList.filter(f => !f.isVirtual);

        // ===== 修改拼接逻辑 =====
        let parts = [];
        if (virtualFiles.length > 0) {
            // 有虚拟文件：按文件分别标记
            virtualFiles.forEach((f, index) => {
                const fileName = f.name || `文件 ${index + 1}`;
                parts.push(`【${fileName}】\n${f.content}`);
            });
            // 如果有用户输入，添加【用户问题】标记
            if (inputText) {
                parts.push(`【用户问题】\n${inputText}`);
            }
        } else {
            // 无虚拟文件：直接使用用户输入（不加任何标记）
            parts.push(inputText);
        }
        let finalText = parts.join('\n\n');
        // ===== 拼接逻辑结束 =====

        // 若既无文件内容也无问题文本，给出提示（但存在真实文件时可继续）
        if (realFiles.length === 0 && !finalText) {
            this.$message.error("请输入您的问题");
            return;
        }

        // 检查真实文件是否全部上传完成
        let uploaded = realFiles.every((item) => item.percentage === 100);
        if (!uploaded) return;

        // 确保会话存在
        if (!this.activeConversation) {
            if (!this.sessionPromise) {
                this.sessionPromise = this.newSession(finalText || '新对话');
            }
            await this.sessionPromise;
            this.sessionPromise = null;
        }

        // 构造用户消息
        let myMsg = {
            id: nanoid(),
            type: "my",
            msg: finalText,
            inputText: inputText,
            fileList: realFiles,
            avatar: humenAvatar,
            robotId,
            sessionId: this.sessionId,
            isCollapse: false,   // 默认展开
        };

        // 清空输入框和文件列表
        this.content = "";
        if (this.$refs.inputRef) {
            this.$refs.inputRef.innerText = "";
        }
        this.fileList = [];

        await this.$store.dispatch('addMessageToConversation', { message: myMsg });

        // 准备请求参数（仅包含已上传的真实文件）
        let fileListForRequest = realFiles.map((item) => {
            if (item.percentage === 100) {
                return {
                    uid: item.uid,
                    name: item.name,
                    type: item.type,
                    file: item.file,
                };
            }
        }).filter(Boolean);

        let params = {
            robotId: robotId,
            sessionId: this.sessionId,
            fileList: fileListForRequest,
            text: finalText,
        };

        await this.getExercisesAnswer(robotId, this.sessionId, params);
    },

    //换行并重新定位光标位置
    textareaRange() {
      var el = this.$refs.inputRef;
      var range = document.createRange();
      //返回用户当前的选区
      var sel = document.getSelection();
      //获取当前光标位置
      var offset = sel.focusOffset;
      //div当前内容
      var content = el.innerHTML; //添加换行符\n
      el.innerHTML = content.slice(0, offset) + "\n" + content.slice(offset); //设置光标为当前位置
      range.setStart(el.childNodes[0], offset + 1);
      //使得选区(光标)开始与结束位置重叠
      range.collapse(true);
      //移除现有其他的选区
      sel.removeAllRanges();
      //加入光标的选区
      sel.addRange(range);
    },

    //监听按键操作
    textareaKeydown(event) {
      if (event.ctrlKey && event.keyCode === 13) {
        //ctrl+enter
        // this.textareaRange()
        event.preventDefault(); // 阻止默认行为
        document.execCommand(
          "insertHTML",
          false,
          "<p style='margin:0;padding:0;'></p>"
        );
      } else if (event.keyCode === 13) {
        //enter
        this.send();
        event.preventDefault(); // 阻止浏览器默认换行操作
        return false;
      }
    },

    //阻塞三秒

    sleep(time) {
      let now = Date.now(); // 获取当前毫秒数
      // 设置while循环，循环条件为：实时时间减去记录时间小于3s，否则则循环结束
      while (Date.now() - now < time) { }
    },

    foldContent() {
      if (this.activeConversation && this.activeConversation.messages.length > 0) {
        this.activeConversation.messages.forEach((item) => {
          this.$set(item, "isCollapse", true);
          this.$set(item, "isEditTestTitle", false);
        });
        this.$message.success("对话列表的内容已折叠")
      }
    },

    // ==================== 移动端拍照取景框相关方法 ====================
    // 点击上传图标：移动端阻止默认事件并弹出动作面板，PC端保持原样
    handleUploadClick(e) {
      if (!this.isAbleSend) return;
      if (this.isMobile) {
        e.preventDefault();
        e.stopPropagation(); // 阻止事件冒泡，避免触发 el-upload 的默认上传
        this.showActionSheet = true;
      }
      // PC 端不做任何操作，事件正常冒泡，由 el-upload 处理
    },

    // 选择拍照
    chooseCamera() {
      this.showActionSheet = false;
      this.openCustomCamera();
    },

    // 选择从相册选择
    chooseAlbum() {
      this.showActionSheet = false;
      this.triggerFileUpload();
    },

    // 在相机界面中点击"相册"按钮时调用
    chooseAlbumFromCamera() {
      this.closeCamera();          // 先关闭相机
      this.chooseAlbum();          // 再打开相册选择
    },

    // 触发隐藏的 el-upload 文件选择（用于移动端相册选择）
    triggerFileUpload() {
      if (this.$refs.upload) {
        // 直接触发 input 点击
        const input = this.$refs.upload.$el.querySelector('input[type=file]');
        if (input) {
          input.click();
        }
      }
    },

    // 打开自定义相机
    async openCustomCamera() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { 
            facingMode: 'environment',
            width: { ideal: 1920 },
            height: { ideal: 1080 }
          }
        });
        this.cameraStream = stream;
        this.showCamera = true;
        this.$nextTick(() => {
          const video = this.$refs.cameraVideo;
          video.srcObject = stream;
          video.play();
          video.onloadedmetadata = () => {
            this.videoWidth = video.videoWidth;
            this.videoHeight = video.videoHeight;
          };
        });
      } catch (err) {
        this.$message.error('无法访问摄像头，请检查权限');
        console.error(err);
      }
    },

    // 关闭相机（释放资源，重置预览状态）
    closeCamera() {
      // 释放预览资源
      if (this.capturedImageUrl) {
        URL.revokeObjectURL(this.capturedImageUrl);
        this.capturedImageUrl = null;
        this.capturedFile = null;
        this.isPreviewing = false;
      }

      if (this.cameraStream) {
        this.cameraStream.getTracks().forEach(track => track.stop());
        this.cameraStream = null;
      }
      this.showCamera = false;
      this.removeTouchListeners();
    },

    // 拍照，截取取景框内图像，生成预览（不提交）
    async takePhoto() {
      const video = this.$refs.cameraVideo;
      if (!video || !this.videoWidth || !this.videoHeight) {
        console.error("Video element or its dimensions are not available.");
        return;
      }

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // --- 核心修改：正确计算取景框在视频流原始像素中的坐标 ---
      const container = this.$refs.cameraContainer;
      // 获取 video 元素在页面上的实际渲染尺寸和位置
      const videoRect = video.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      // 获取 video 元素内部视频画面的实际渲染尺寸（考虑了 object-fit 的效果）
      const videoDisplayWidth = videoRect.width;
      const videoDisplayHeight = videoRect.height;
      const videoStreamRatio = this.videoWidth / this.videoHeight;
      const videoDisplayRatio = videoDisplayWidth / videoDisplayHeight;

      let renderedVideoWidth, renderedVideoHeight, renderedVideoOffsetX, renderedVideoOffsetY;

      if (videoDisplayRatio > videoStreamRatio) {
        renderedVideoHeight = videoDisplayHeight;
        renderedVideoWidth = renderedVideoHeight * videoStreamRatio;
        renderedVideoOffsetX = (videoDisplayWidth - renderedVideoWidth) / 2;
        renderedVideoOffsetY = 0;
      } else {
        renderedVideoWidth = videoDisplayWidth;
        renderedVideoHeight = renderedVideoWidth / videoStreamRatio;
        renderedVideoOffsetX = 0;
        renderedVideoOffsetY = (videoDisplayHeight - renderedVideoHeight) / 2;
      }

      // 计算取景框在屏幕坐标系中的绝对位置和尺寸
      const cropBoxScreenLeft = containerRect.left + (this.cropBox.left * containerRect.width);
      const cropBoxScreenTop = containerRect.top + (this.cropBox.top * containerRect.height);
      const cropBoxScreenWidth = this.cropBox.width * containerRect.width;
      const cropBoxScreenHeight = this.cropBox.height * containerRect.height;

      // 将屏幕坐标映射到 video 元素内部渲染视频的坐标系
      const cropBoxVideoElementLeft = (cropBoxScreenLeft - videoRect.left - renderedVideoOffsetX);
      const cropBoxVideoElementTop = (cropBoxScreenTop - videoRect.top - renderedVideoOffsetY);

      // 将 video 元素内部的坐标映射回原始视频流的像素坐标
      const scaleX = this.videoWidth / renderedVideoWidth;
      const scaleY = this.videoHeight / renderedVideoHeight;

      const cropX = cropBoxVideoElementLeft * scaleX;
      const cropY = cropBoxVideoElementTop * scaleY;
      const cropWidth = cropBoxScreenWidth * scaleX;
      const cropHeight = cropBoxScreenHeight * scaleY;

      canvas.width = cropWidth;
      canvas.height = cropHeight;

      // 从原始视频流中裁剪指定区域绘制到canvas
      ctx.drawImage(
        video,
        cropX, cropY, cropWidth, cropHeight,
        0, 0, cropWidth, cropHeight
      );

      // 生成 Blob 并进入预览
      canvas.toBlob((blob) => {
        const fileName = `camera_${Date.now()}.jpg`;
        const file = new File([blob], fileName, { type: 'image/jpeg' });
        file.uid = Date.now() + Math.random().toString(36).substr(2);

        this.capturedFile = file;
        this.capturedImageUrl = URL.createObjectURL(blob);
        this.isPreviewing = true;
      }, 'image/jpeg', 0.9);
    },

    // 确认提交拍摄的照片
    async confirmPhoto() {
      if (!this.capturedFile) return;
      if (this.confirming) return;
      this.confirming = true;

      try {
        const isValid = await this.handleBeforeUpload(this.capturedFile, this.fileList);
        if (isValid === false) {
          this.confirming = false;
          return;
        }
        await this.handleFileUpload({ file: this.capturedFile });
        this.closeCamera();
      } catch (err) {
        console.error('确认照片出错', err);
        this.$message.error('提交失败，请重试');
      } finally {
        this.confirming = false;
      }
    },

    // 重拍（回到实时取景）
    retakePhoto() {
      if (this.capturedImageUrl) {
        URL.revokeObjectURL(this.capturedImageUrl);
        this.capturedImageUrl = null;
        this.capturedFile = null;
      }
      this.isPreviewing = false;
    },

    // 拍照，截取取景框内图像，生成文件并加入上传列表（原方法已弃用，保留备用，但实际被上面的 takePhoto 覆盖）
    // 原 takePhoto 已替换，注意不要重复定义，上面已覆盖。

    // ==================== 取景框拖动调整大小 ====================
    startDrag(e) {
      e.preventDefault();
      if (this.isResizing) return;
      const container = this.$refs.cameraContainer;
      const rect = container.getBoundingClientRect();
      const touch = e.touches[0];
      this.dragStartData = {
        startX: touch.pageX,
        startY: touch.pageY,
        startLeft: this.cropBox.left,
        startTop: this.cropBox.top,
        startWidth: this.cropBox.width,
        startHeight: this.cropBox.height,
        containerWidth: rect.width,
        containerHeight: rect.height,
      };
      this.isDragging = true;
      this.addTouchListeners();
    },

    startResize(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.isDragging) return;
      const container = this.$refs.cameraContainer;
      const rect = container.getBoundingClientRect();
      const touch = e.touches[0];
      this.dragStartData = {
        startX: touch.pageX,
        startY: touch.pageY,
        startLeft: this.cropBox.left,
        startTop: this.cropBox.top,
        startWidth: this.cropBox.width,
        startHeight: this.cropBox.height,
        containerWidth: rect.width,
        containerHeight: rect.height,
      };
      this.isResizing = true;
      this.addTouchListeners();
    },

    onTouchMove(e) {
      e.preventDefault();
      if (!this.isDragging && !this.isResizing) return;
      const touch = e.touches[0];
      const { startX, startY, startLeft, startTop, startWidth, startHeight, containerWidth, containerHeight } = this.dragStartData;

      const deltaX = touch.pageX - startX;
      const deltaY = touch.pageY - startY;

      // 将像素变化转换为百分比
      const deltaXPercent = deltaX / containerWidth;
      const deltaYPercent = deltaY / containerHeight;

      if (this.isDragging) {
        // 拖动整体
        let newLeft = startLeft + deltaXPercent;
        let newTop = startTop + deltaYPercent;

        // 限制边界，确保不超出父容器
        newLeft = Math.max(0, Math.min(1 - startWidth, newLeft));
        newTop = Math.max(0, Math.min(1 - startHeight, newTop));

        this.cropBox.left = newLeft;
        this.cropBox.top = newTop;
      } else if (this.isResizing) {
        // 调整大小（以右下角为锚点）
        let newWidth = startWidth + deltaXPercent;
        let newHeight = startHeight + deltaYPercent;

        // 最小限制
        newWidth = Math.max(0.1, Math.min(1 - startLeft, newWidth));
        newHeight = Math.max(0.1, Math.min(1 - startTop, newHeight));

        this.cropBox.width = newWidth;
        this.cropBox.height = newHeight;
      }
    },

    onTouchEnd(e) {
      e.preventDefault();
      this.isDragging = false;
      this.isResizing = false;
      this.removeTouchListeners();
    },

    addTouchListeners() {
      document.addEventListener('touchmove', this.onTouchMove, { passive: false });
      document.addEventListener('touchend', this.onTouchEnd, { passive: false });
      document.addEventListener('touchcancel', this.onTouchEnd, { passive: false });
    },

    removeTouchListeners() {
      document.removeEventListener('touchmove', this.onTouchMove);
      document.removeEventListener('touchend', this.onTouchEnd);
      document.removeEventListener('touchcancel', this.onTouchEnd);
    },

    // ---- 新增：停止生成 ----
    stopGeneration() {
      const chat = this.currentGeneratingChat;
      if (chat) {
        pubsub.publish('stopGeneration', chat);
      }
    }
  },
  watch: {
    robotId(newVal, oldVal) {
      this.fileList = [];
    },
  },
  computed: {
    activeConversation() {
      return this.$store.getters.activeConversation;
    },
    chatList() {
      return (
        this.messageStorage[this.robotId] &&
        this.messageStorage[this.robotId][this.sessionId] &&
        this.messageStorage[this.robotId][this.sessionId].chatList
      );
    },
    isShowFileList() {
      return this.fileList.every((file) => file.sessionId === this.sessionId);
    },
    isAbleSend() {
      if (this.robotId === "knowledgeBase") {
        if (this.isBuiltLib) {
          return true;
        }
      } else {
        return true;
      }
    },
    ...mapState([
      "questions",
      "chatType",
      "userInfo",
      "messageStorage",
      "sessionId",
      "robotId",
      "robots",
      "isMobile",
    ]),
    getInputClass() {
      if (this.fileList.length > 0) {
        let isUploaded = this.fileList.every((item) => item.percentage === 100);
        return isUploaded ? "send-active" : "";
      } else {
        if (this.content && this.content.trim() != "") {
          return "send-active";
        } else {
          return "";
        }
      }
    },
    // 取景框样式
    cropBoxStyle() {
      return {
        left: this.cropBox.left * 100 + '%',
        top: this.cropBox.top * 100 + '%',
        width: this.cropBox.width * 100 + '%',
        height: this.cropBox.height * 100 + '%',
      };
    },

    // ---- 新增：判断当前是否有正在生成的消息 ----
    isGenerating() {
      if (!this.activeConversation) return false;
      const messages = this.activeConversation.messages;
      for (let i = messages.length - 1; i >= 0; i--) {
        const msg = messages[i];
        if (msg.type !== 'my' && msg.type !== 'new' && msg.isDone === 0 && msg.controller) {
          return true;
        }
      }
      return false;
    },
    // ---- 新增：获取正在生成的消息对象 ----
    currentGeneratingChat() {
      if (!this.activeConversation) return null;
      const messages = this.activeConversation.messages;
      for (let i = messages.length - 1; i >= 0; i--) {
        const msg = messages[i];
        if (msg.type !== 'my' && msg.type !== 'new' && msg.isDone === 0 && msg.controller) {
          return msg;
        }
      }
      return null;
    }
  },
};
</script>

<style lang='scss' scoped>
$base_color: #409eff;
$bg_color: rgb(200, 200, 200);

.footer-wrapper {
  width: 100%;
  .menu {
    z-index: 3;
  }
}

#footer {
  display: flex;
  margin: 0;
  // margin-left: 74px;
  position: relative;
  width: 100%;

  .icon-new,
  .icon-fold {
    margin-right: 12px;
    // line-height: 65px;
    font-weight: 600;
    z-index: 101;
    cursor: pointer;
    fill: var(--txt-default-color);
    width: 23px;

    &:hover {
      fill: #2454ff;
    }
  }
}


.isDsiabledToSend {
  cursor: not-allowed !important;
}

.create-wrap {
  display: none;
  position: absolute;
  top: -60px;
  left: 0;
  padding: 12px 0;
  width: 100%;
  background: linear-gradient(0deg,
      var(--bg_white_1, #fff) 23.17%,
      #f6f7f9 108.94%);
}

.create-session {
  width: fit-content;
  border-radius: 12px;
  box-shadow: 0 6px 10px 0 rgba(42, 60, 79, 0.1);
  border: 1px solid var(--box_stroke_grey_1, #d3d7dd);
  background: var(--bg_white_1, #fff);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  overflow: hidden;
  transition: width 0.6s cubic-bezier(0.68, -0.55, 0.27, 1.55),
    height 0.6s cubic-bezier(0.68, -0.55, 0.27, 1.55),
    transform 0.6s cubic-bezier(0.68, -0.55, 0.27, 1.55),
    opacity 0.3s cubic-bezier(0.68, -0.55, 0.27, 1.55);
  box-sizing: border-box;
  z-index: 1000;

  &:hover {
    cursor: pointer;
    background: var(--angent_special_grey_1, #f6f7f9);

    .create-icon {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAMAAACfvvDEAAAAAP1BMVEVHcEwgUP8lVf8kVP8lVf8lVf8kVP8kVP8kVP8oWP8kVP8lVf8kVf8jU/8jU/8kVP8kVP8lVP8mVv8kVP8kVP/bZoceAAAAFHRSTlMAEJ/PYN+AQL8g7zCvUJCPcKBff89zX3gAAAFQSURBVDjLzZXLYoQgDEUFggjiONOe///WLsSBIPaxa5ZwzPMSp+l/mVlFRIL5AQu7p5i34RtuQZmXm7CZi9k4ANczrrPW5tO73y7gRwJgkbOU7XWwH73Hg1NFxGWARg/w6APNAGltjzzAfE1eALzpDuZRQ/obD9gmaanNeQDJqAPLZUzwzs2k1umiXc4q4Ayk04d22ZEmAaV7G7BMd+SUgWdN+nFPPmtuGSjjXXdrrSvD34+MAuBqQeFddWNHdyLge3LrRLfdksZrJcdTPIV8AUXdUUQkA1lEigBDbc3va99qcSNyqSENdQpXUk2wm/tTkXsbMUCjnin6UvU7oCh9NpmaZoMYlCoCwD5eAw99lwE+x6hTBR/DyaONcbxb2z3j8SLq9Hug+D0M32er9OhOYbhFmbsujZl76yqIr3QDXreGkeyvnAt3iz5oi3/8U3wBvtYm/JDxVt8AAAAASUVORK5CYII=);
    }

    .create-text {
      color: var(--txt_stroke_blue_1, #2454ff);
    }
  }

  .create-icon {
    width: 20px;
    height: 20px;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAMAAACfvvDEAAAAbFBMVEVHcEwbICogICAcICwaICobICsYICgbICkaICkcICggICgbICsbICkgIDAbICoaICoaICkbICkbICgdICkaICoaICkaICkaICgbICoaICobICkbICgaICkcICkbICsgICUaICkZICkaICoaICkQDfxFAAAAI3RSTlMAnxBAgGAgv99AIDCQEO+vz49gUJ/voIDPz3BfUK+PMK9wf81wiksAAAFkSURBVDjLzZXHdoMwEEUlsAqm47gkttPu//9jFoDVUMoubwn3TH0MQvwvFbVSSpXFD1g5WhZZWX7DGQJZlUnbk0juN8B6zXuRUvZrdHtLwGsHgFFrK4fTzF7jiDNX+c+02UD3FqCJE50BjrX/yALs0uInAOvNVmXABd2FIZ+8opUbTgMciyCkdkV38Kit7fygJgy5CxKegeMaIwwZkW0HLBY4AEbkSHEHPlzRTZ58cbXdgWW99SilHIBBSjnOE6iAZ9dQ+eja0zwdDdiYPESmu2XJ1oZO1kII8ebIE7C4WyulVA/0SqnFgJUbze97P7jmtkgDTMsWcFtIyWCDBpBhOkeOfsYKPPcIbZeuHwmnwJ+D9z1XzuUtgSsqgNftM9CE73qAz230EjQ8L+d962IIHX472uYPUeTfGcWO6YVTkdP1ZTXGYAIN6dE4k5eOaj91GTC9GsXU25Qbqtyhr0Lt//in+AL4WUG9sH7HowAAAABJRU5ErkJggg==);
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;
  }

  .create-text {
    margin-left: 6px;
    color: var(--txt_icon_black_1, #1a2029);
    font-family: PingFang SC;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }
}

.footer-input {
  box-sizing: border-box;
  width: 100%;

  padding: 12px 10px;
  // border: 1px solid $bg_color;
  border: 1px solid #e5e5e5;
  border-radius: 20px;
  background-color: var(--main-color, #434346);
  box-shadow: 0 6px 10px 0 rgba(42, 60, 79, 0.1);
}

.footer-bottom {
  display: flex;
  flex: 1;
  align-items: center;
  margin-right: 10px;

  .send-btn,
  .loading-btn,
  .stop-btn {   /* 新增 stop-btn 样式 */
    display: flex;
    padding: 0;
    width: 48px;
    height: 40px;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    color: $bg_color;
    border-radius: 10px;
    z-index: 9;
    cursor: pointer;
  }

  .stop-btn {
    &:hover {
      background: rgba(255, 77, 79, 0.1);
    }
  }




  .icon-new {
    margin-left: 12px;
    width: 26px;
    height: 26px;
    color: var(--txt-default-color);
  }

  .icon-fold {
    padding-right: 5px;
    width: 26px;
    height: 26px;
    font-weight: 500;
    color: var(--txt-default-color);
  }

  .upload-wrapper {
    .el-tooltip {
      display: flex;
      align-items: center;

      svg {
        margin-left: -5px;
        margin-top: 3px;
        border-radius: 10px;

        .fill-first {
          // fill: var(--txt-default-color);
          fill: #2b2e30;
        }

        &:hover {
          .fill-first {
            fill: #2454ff;
          }
        }
      }
    }
  }

  .loading-btn i {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;

    .el-loading-spinner {
      margin-top: 0%;
      transform: translateY(-50%);
    }
  }

  .input-icon {
    margin-left: 1rem;
    z-index: 99;
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
    // background: url(../../assets/image/chat/upload_file_btn_hover.svg);
    // background-size: 100%;
    // background-repeat: no-repeat;
    position: relative;
    font-size: 26px;
    opacity: 0.8;

    &:hover {
      color: #2454ff;
    }

    &.voice-icon {
      font-size: 24px;
      margin-left: -5px;
    }
  }
}

.editor {
  flex: 1;
  text-align: left;
  transition: all 0.6s ease;
  display: block;
  box-sizing: border-box;
  padding: 5px 10px;
  //   color: #000;
  color: var(--txt-default-color);
  outline: none;
  border: none;
  resize: none;
  font-size: 1rem;
  line-height: 1.5rem;
  font-family: PingFang SC;
  font-style: normal;
  scrollbar-width: none;
  overflow-y: auto;
  max-height: 20rem;
  min-height: 1rem;

  &:focus {
    //border: 1px solid $base_color;
  }

  a {
    color: $base_color;
  }

  &:empty:before {
    content: "有什么想问的，尽管告诉我～";
    font-size: 14px;
    color: $bg_color;
  }

  &:focus:before {
    content: none;
  }
}

.voice {
  margin-left: 6px;
  cursor: pointer;

  img {
    width: 22px;
    height: 22px;
  }
}

.active {
  border: 1px solid $base_color !important;
}

.send-active {
  color: $base_color;
}

//调节input输入框
.el-input .el-input__inner {
  padding-left: 10px !important;
  height: 2.5rem !important;
  line-height: 2.5rem !important;
}

//控制多选按钮的大小
.el-checkbox-button--medium .el-checkbox-button__inner {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 10px !important;
  height: 2.5rem;
  //line-height: 2.5rem;
}

.el-checkbox-button.is-checked .el-checkbox-button__inner {
  color: #fff;
  background-color: rgba(160, 193, 225, 0.5) !important;
  border-color: #409eff !important;
  box-shadow: -1px 0 0 0 #8cc5ff;
}

$font_size: clamp(14px, 0.18rem, 20px);

.isMobile {
  font-size: 0.36rem;

  .editor {
    line-height: 1.2;
    font-size: $font_size;
    // height: 0.3rem;
    min-height: 0.3rem !important;
    max-height: 300px;
  }



  .icon-new {
    margin-right: 5px !important;
    width: 0.32rem !important;
    height: 0.32rem !important;
    font-size: 0.4rem !important;
    font-weight: 600;

  }

  .icon-fold {
    margin-right: 5px !important;
    width: 0.32rem;
    height: 0.3rem;
  }



  .upload-wrapper,
  .upload-demo {
    height: 0.36rem;
    width: 0.36rem;

    svg {
      padding-top: 3px;
      width: 0.4rem !important;
      height: 0.4rem !important;
    }
  }

  .el-icon-s-promotion {
    font-size: 0.4rem;
  }

  .send-btn,
  .loading-btn,
  .stop-btn {
    width: 0.48rem;
    height: 0.4rem;
  }
}

/* 动作面板样式 */
.action-sheet-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(246, 253, 253, 0.8);
  z-index: 9999;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.action-sheet {
  width: 100%;
  background: rgb(229, 243, 220);
  border-radius: 16px 16px 0 0;
  padding: 10px 0;
  color:rgb(108, 6, 241);
}
.action-sheet-item {
  padding: 15px 0;
  text-align: center;
  font-size: 16px;
  border-bottom: 2px solid rgb(175, 230, 243);
  cursor: pointer;
}
.action-sheet-item.cancel {
  border-bottom: none;
  color: #999;
}

/* 相机界面样式 */
.camera-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.camera-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.camera-video {
  flex: 1;
  width: 100%;
  object-fit: cover;
}
.crop-box {
  position: absolute;
  border: 2px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);
  pointer-events: auto; /* 允许交互 */
}
.crop-area {
  width: 100%;
  height: 100%;
  background: transparent;
  pointer-events: none; /* 区域本身不拦截事件 */
}
.crop-hint {
  color: white;
  font-size: 14px;
  text-align: center;
  line-height: 1.2;
  padding: 5px;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  z-index: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
}
.resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 30px;
  height: 30px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50% 0 50% 0;
  cursor: nwse-resize;
  pointer-events: auto;
  z-index: 2;
}
.camera-footer {
  position: absolute;
  bottom: 30px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
  padding: 0 20px;
  box-sizing: border-box;
  z-index: 10;
}
.btn-cancel,
.btn-capture,
.btn-album {
  padding: 12px 30px;
  border-radius: 30px;
  border: none;
  font-size: 16px;
  background: white;
  color: #333;
  cursor: pointer;
}
.btn-capture {
  background:rgb(108, 6, 241);
  color: white;
}
.btn-album {
  background: #fff;
  color:rgb(108, 6, 241);
}

/* 新增：预览层样式 */
.camera-preview {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 20;
}
.camera-preview img {
  max-width: 100%;
  max-height: 80%;
  object-fit: contain;
}
.preview-actions {
  display: flex;
  gap: 40px;
  margin-top: 20px;
  align-items: center;
}
.btn-retake {
  padding: 10px 30px;
  border-radius: 30px;
  border: none;
  background: rgba(255,255,255,0.8);
  color: #333;
  font-size: 16px;
  cursor: pointer;
}
.btn-confirm {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #4CAF50;
  color: white;
  font-size: 36px;
  line-height: 64px;
  text-align: center;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0,0,0,0.3);
  transition: transform 0.1s;
}
.btn-confirm:active {
  transform: scale(0.9);
}
</style>

<style lang="scss">
.global-drop-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  pointer-events: none; /* 允许拖拽穿透，但不影响覆盖层显示 */
}
.drop-hint {
  font-size: 28px;
  color: #409eff;
  background: rgba(255, 255, 255, 0.6);
  padding: 30px 60px;
  border-radius: 20px;
  border: 2px dashed #409eff;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  font-weight: bold;
  user-select: none;
}
</style>